import { AHText } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { WorkspaceTodoEditMainEditedInfo_Todo$key } from "./__generated__/WorkspaceTodoEditMainEditedInfo_Todo.graphql";
import { FormattedMessage } from "react-intl";
import { FormattedDateInWorkspace } from "../../../../../common/dates/FormattedDate";

export function EditedBy(props: {
  todo: WorkspaceTodoEditMainEditedInfo_Todo$key;
}) {
  const data = useFragment(
    graphql`
      fragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {
        updatedBy {
          id
          name
        }

        updatedAtDate {
          ...FormattedDate
        }
      }
    `,
    props.todo
  );

  return (
    <AHText type="detail" spaceRight="small">
      <FormattedMessage
        description="Workspace Todo Edit Edited By"
        defaultMessage="Saved <date>{editedAtDate}</date> by {editedByName}"
        values={{
          editedByName: data.updatedBy?.name ?? "",
          editedAtDate: data.updatedAtDate ? (
            <FormattedDateInWorkspace date={data.updatedAtDate} />
          ) : (
            ""
          ),
          date: (msg) => <>{msg}</>,
        }}
      />
    </AHText>
  );
}
